import InactiveProfessionalModal from './InactiveProfessionalModal.js'
export default InactiveProfessionalModal